import React, { useState, useEffect } from "react";
import { PackageId } from "../../utils/helper";
import PackageCard from "../../component/PackageCard";
import Footer from "../../comman/Footer";
import Header from "../../comman/Header";
import international from "../../assets/image/Finalinternational.png";
import { GetPackageById } from "../../Service/api.sevice";
import HomeHeroBanner from "../../component/HomeHeroBanner";

function International() {
  const [packageData, setPackageData] = useState(null);

  useEffect(() => {
    GetDomesticData();
  }, []);

  const GetDomesticData = async () => {
    const getId = PackageId.InternationalPackage;
    const responseData = await GetPackageById(getId, 0);
    setPackageData(responseData?.data);
  };

  return (
    <>
      <Header />
      <HomeHeroBanner Image={international} Text={``} />
      <section className="center_container">
        <div className="card_container">
          {packageData &&
            packageData.length > 0 &&
            packageData.map((data, index) => {
              return <PackageCard data={data} key={`packageData${index}`} />;
            })}
        </div>
      </section>
      <Footer />
    </>
  );
}

export default International;
